module.exports = __webpack_public_path__ + "static/img/purple-bg.ffcbb999.jpg";